module.exports = __webpack_public_path__ + "static/landingbuilder-4-d362f480e496e6b9d14270f95606f758.png";